// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.warningtext {\r\n  color: red !important;\r\n  font-size: 11px;\r\n  font-weight: bold;\r\n  background: none;\n}\n.chip-class {\r\n  text-transform: lowercase !important;\n}\n.validateError {\r\n  color: red;\r\n  font-size: 1em;\r\n  background: none;\n}\n.invisible {\r\n  opacity: 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
